<nav class="flex w-full flex-1 items-center px-2 md:px-3 lg:px-4 xl:px-6">
  <ul
    class="flex h-full w-full items-center justify-between gap-2 sm:justify-start sm:gap-4 md:gap-6 lg:gap-4"
  >
    @for (item of menu; track item.name) {
      <li class="min-w-0 flex-1 sm:flex-none">
        <a
          [routerLink]="item.url"
          routerLinkActive="active"
          class="group relative flex h-16 w-full flex-col items-center gap-2 overflow-hidden p-2 text-neutral-low-medium transition-all duration-150 before:absolute before:bottom-0 before:h-1 before:w-9 before:rounded-full hover:text-brand-primary-pure sm:size-full sm:flex-row sm:gap-2 sm:px-0 sm:py-2.5 sm:before:left-0 sm:before:h-0.5 sm:before:w-full lg:min-w-16 xl:min-w-20 xl:gap-3 [&.active]:text-brand-primary-pure [&.active]:before:bg-brand-primary-pure"
        >
          <ng-icon size="24" [name]="item.icon" />
          <span class="truncate text-xs/none font-medium sm:hidden">{{
            item.alias || item.name
          }}</span>
          <span class="hidden truncate text-sm/none font-medium lg:block">{{
            item.name
          }}</span>
        </a>
      </li>
    }
  </ul>
</nav>
